import clsx from "clsx";

export const CardLoader = ({ className, innerClass, count = 3 }) => {
  return (
    <div
      className={clsx(
        "flex items-center h-[225.36px] w-full px-4 gap-8",
        className
      )}
    >
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className={clsx(
            innerClass,
            "w-full h-[170px] animate-pulse bg-gray-300 rounded-[10px]"
          )}
        />
      ))}
    </div>
  );
};
